<template>
	<div id="main">
		<div class="test_main" style="font-size: 12px;">
			<div class="nr_left">
				<div class="test">

					<div class="test_title">
						<p class="test_time">
							<i class="jrfont jr_alarm"></i><b class="alt-1"><time class="countdown-alt-1" v-text="timerTickerString"></time></b>
						</p>
						<font v-if="!btntext"><input type="button" name="test_jiaojuan" @click="doSubmit()"  value="交卷"></font>
						<font  v-if="btntext"><input type="button" name="test_jiaojuan" @click="again()" value="重做"></font>

					</div>

					<div class="test_content">
						<div class="test_content_title"  style="padding-left: 20px;box-sizing: border-box;">
							<p>
								<span>共</span><i class="content_lit">{{allQuestion.length}}</i><span>题，</span><span>合计</span><i class="content_fs">{{Score}}</i><span>分</span>
							</p>
						</div>
					</div>

					<div class="test_content_nr">
						<div id='stemId' v-if="Stem" v-html="Stem" style="padding:10px 20px;font-size:14px;line-height:20px;color:#000"></div>
						<ul>

							<li v-for="(item, index) in allQuestion" v-bind:key="item.QuestionId" :id="'answer_'+index" >
								<div class="test_content_nr_tt">
									<i>{{index+1}}</i><span>({{item.QuestionType}} {{item.Score}}分)</span><font>{{item.QuestionMain}}</font><b class="icon iconfont"></b>
								</div>

								<div class="test_content_nr_main">
									<ul>
										<li class="option" v-for="Anitem in item.Answers" >
											<input :disabled="disabled" @change="select(item.QuestionId,Anitem.Selection)" :value="Anitem.Selection" v-if="item.QuestionTypeId != 2&&item.QuestionTypeId != 4" type="radio" v-model="AnswerList[index].Answer"  class="radioOrCheck" :name="index" :id="'answer_'+index+'_'+Anitem.Selection">
											<input :disabled="disabled" @change="select2(item.QuestionId,Anitem.Selection)" :value="Anitem.Selection" v-if="item.QuestionTypeId==2 || item.QuestionTypeId==4"  type="checkbox" v-model="AnswerList[index].ArrAnswer"  class="radioOrCheck" :name="index" :id="'answer_'+index+'_'+Anitem.Selection">
											<label :for="'answer_'+index+'_'+Anitem.Selection">
												{{Anitem.Selection}}.<p class="ue" style="display: inline;">{{Anitem.Main}}</p>
											</label>
										</li>
									</ul>
								</div>
							</li>

						</ul>
					</div>

				</div>
			</div>
			<div class="nr_right">
				<div class="nr_rt_main">
					<div class="rt_nr1">
						<div class="rt_nr1_title">
							<h1>
								答题卡
							</h1>
							<p class="test_time">
								<i class="jrfont jr_alarm"></i><b class="alt-1"><time class="countdown-alt-1" v-text="timerTickerString"></time></b>
							</p>
						</div>

							<div class="rt_content">
								<div class="rt_content_tt">
									<!-- <h2>单选题</h2> -->
									<p>
										<span>共</span><i class="content_lit">{{allQuestion.length}}</i><span>题</span>
									</p>
								</div>
								<div class="rt_content_nr answerSheet" style="height: 550px;overflow-y: scroll;">
									<ul>
										<li v-if="Stem" @click="jump('#stemId')">案例</li>
										<li v-for="(item,index) in allQuestion.length" ><span style="display: block;font-size: 12px;" @click="jump('#answer_'+index)" :class="AnswerList[index].Answer && 'hasBeenAnswer'"  >{{index+1}}</span></li>

									</ul>
								</div>
							</div>

					</div>

				</div>
			</div>
		</div>
	</div>

</template>

<script>
	function  setCookie(key, value) {
			// 设置过期原则
			if (!value) {
				localStorage.removeItem(key)
			} else {
				var Days = 60; // 
				var exp = new Date();
				localStorage[key] = JSON.stringify({
					value,
//          expires: exp.getTime() + Days * 24 * 60 * 60 * 1000
					expires: exp.getTime() + Days * 60 *1000
				})
			}
		}
		function getCookie(name) {
			try {
				let o = localStorage[name]?JSON.parse(localStorage[name]):""
				if(!o || o.expires < Date.now()) {
					return null
				} else {
					return o.value
				}
			} catch(e) {
				// 兼容其他localstorage 
				console.log(e)
				return localStorage[name]
			} finally {}
		}
	export default {
		data() {
			return {
				radio:'1',
				Stem:'',
				allQuestion: [],
				disabled:false,
				timerTickerString: "",
				timerTotal: 0,
				timerSpend: 0,
				timerTicker: 0,
				isLoaded: false,
				Score:'',
				isCardOpen: !1,
				AnswerList:[],
				btntext:0,
				aaa:['A','B']
			}
		},
		methods:{
			select:function(QuestionId,Selection){
				console.log(QuestionId)
				console.log(Selection)
				for(let x in this.AnswerList){
					if(this.AnswerList[x].QuestionId == QuestionId){
						this.AnswerList[x].Answer = Selection
					}
				}
				localStorage.setItem('LocalAnswerList',JSON.stringify(this.AnswerList))
				console.log(this.AnswerList)
			},
			jump:function(a){
				console.log(a)
				const anchorEle = document.querySelector(a);
				if (!!anchorEle ) {
				  anchorEle .scrollIntoView(true);
				}
			},
			select2:function(QuestionId,Selection){
				// console.log(QuestionId,Selection)
				for(let x in this.AnswerList){
					if(this.AnswerList[x].QuestionId == QuestionId){
						var arr = this.AnswerList[x].Answer
						// console.log(arr)
						if(arr.length > 0){
							if(arr.indexOf(Selection) < 0){
								// console.log(3)
								console.log(Selection)
								console.log(this.AnswerList[x].ArrAnswer)
								// this.AnswerList[x].ArrAnswer.push(Selection)
								console.log(this.AnswerList[x].ArrAnswer)
								this.AnswerList[x].Answer = (this.AnswerList[x].Answer+ Selection).split('').sort().join('')
								console.log(this.AnswerList[x].ArrAnswer)
							}else{
								console.log(arr.indexOf(Selection))
								arr = arr.replace(Selection,'')
								console.log(arr)
								// console.log(arr.split('').sort().join(''))
								this.AnswerList[x].Answer = arr.split('').sort().join('')
								// this.AnswerList[x].ArrAnswer.splice(arr.indexOf(Selection),1)
								// console.log(this.AnswerList[x].ArrAnswer)
							}
						}else{
							this.AnswerList[x].Answer = (this.AnswerList[x].Answer+ Selection).split('').sort().join('')
							// this.AnswerList[x].ArrAnswer.push(Selection)
							console.log(this.AnswerList[x].ArrAnswer)
						}
						console.log(this.AnswerList[x].ArrAnswer)

					}
				}
				localStorage.setItem('LocalAnswerList',JSON.stringify(this.AnswerList))
			},
			doSubmit:function(){
				var e = this;
				var iscomplete = 1
				for(let x in e.AnswerList){
					console.log(e.AnswerList[x].Answer)
					if(e.AnswerList[x].Answer == ''){
						iscomplete = 2
						break ;
					}
				}
					iscomplete==1?e.submitPaper():this.$confirm('您还有题目未作答，确认提交?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning',
					  center: true
					}).then(() => {
						var i = 0,
							t = 0;
						i = Math.floor(e.timerTicker / 60), t = Math.floor(e.timerTicker) - 60 * i, e.timerSpend = t > 30 ? i + 1 :
							i, e.submitPaper()
					}).catch(() => {
					  this.$message({
						type: 'info',
						message: '已取消删除'
					  });
					});

			},
			submitPaper: function(e) {
				var i = this;
				console.log(this.AnswerList)
				this.axios.post("/api/CompetitionRanking/SubmitHand",{
						// PlaybackId: i.$route.params.PlaybackId,
						// MemberId: i.cookie.get('MemberId'),
						// UseTime: i.timerSpend,
						AnswerList: this.AnswerList
					}).then(function (data) {
					console.log(data)
					window.clearInterval(i.timerCounter);
					
						i.$confirm('考试结束，您的成绩为'+data.data.data+'分', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							i.$router.go(-1);
							localStorage.removeItem('LocalAnswerList')
						}).catch(action => {
							i.$router.go(-1);
							localStorage.removeItem('LocalAnswerList')
						})

					})

			},
			formatTimer: function () {
			    var that = this,
			        minute = 0,
			        second = 0;//时间默认值
			    minute = Math.floor(that.timerTicker / 60);
			    second = Math.floor(that.timerTicker) - (minute * 60);
			    if (minute <= 9) minute = '0' + minute;
			    if (second <= 9) second = '0' + second;
			    that.timerTickerString = minute + ":" + second;
			},
			setTimer: function () {
			    var that = this;
			    that.timerCounter = window.setInterval(function () {
			        that.formatTimer();
					// console.log(1111)
			        if (that.timerTicker > 0) {
			            that.timerTicker--;
			        }else {
			            window.clearInterval(that.timerCounter);
						// that.$confirm('测试已经结束，试卷已自动提交!', '提示', {
						//   confirmButtonText: '确定',
						//   cancelButtonText: '取消',
						//   type: 'warning',
						//   center: true
						// }).then(() => {
						// 	that.timerSpend = that.timerTotal;
						// 	that.submitPaper();
						// }).catch(() => {
						  that.timerSpend = that.timerTotal;
						  that.submitPaper();
						// });
			        }
					// localStorage.setItem('LocaltimerTicker',this.timerTicker)
					// console.log(that.timerTicker)
			    }, 1000);

			},
			again(){
				this.$router.go(0)
			},
			StartExamination(){
				var that = this
				this.axios.post("/api/CompetitionRanking/StartExamination").then(function (data) {
					if(!data.data.Success){
						that.$confirm(data.data.ErrorMsg, '提示', {
						  confirmButtonText: '确定',
						  cancelButtonText: '取消',
						  type: 'warning',
						  center: true
						}).then(() => {
							window.clearInterval(that.timerCounter);
							that.$router.go(-1);
						}).catch(() => {
							window.clearInterval(that.timerCounter);
							that.$router.go(-1);
						});
					}else{
						that.timerTicker = data.data.data
					}
				})
			}
		},
		updated: function () {
			var that = this;
			if (that.isLoaded) {
				// localStorage.removeItem('LocalAnswerList')
			    that.isLoaded = false;
				this.$confirm('开始答题后不能退出页面否则可能会导致考试成绩无效，您确定开始答题吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  center: true
				}).then(() => {
					that.setTimer();
					that.StartExamination();
				}).catch(() => {
				  that.$router.go(-1);
				});
			}
		},
		created() {
			var _that = this
			// localStorage.removeItem('LocalAnswerList')
			 window.clearInterval(_that.timerCounter);
			console.log(_that.$route.params.PlaybackId)
			this.axios.get("/api/CompetitionRanking/GetExam")
			.then(function (data) {
				console.log(data.data.data)
				// data.data = JSON.parse(data.data)

				if (data.data.Success) {
					_that.isLoaded = true;
					_that.Stem = data.data.data.Stem
					_that.Score = data.data.data.Score;
					_that.paperTitle = data.data.data.PageTitle;
					_that.allQuestion = data.data.data.QuestionList;
					_that.isSuccessed = true;
					_that.timerTotal = data.data.data.TestTime;
					// var LocaltimerTicker = localStorage.getItem('LocaltimerTicker')

					_that.timerTicker = data.data.data.TestTime * 60;

					var LocalAnswerList = localStorage.getItem('LocalAnswerList')
					// console.log(LocalAnswerList)
					// LocalAnswerList?this.AnswerList =localStorage.getItem('LocalAnswerList'):''
					// console.log(this.AnswerList)
					if(LocalAnswerList){
						_that.AnswerList =JSON.parse(localStorage.getItem('LocalAnswerList'))
					}else{
						for(let x in data.data.data.QuestionList){
							let str = {
								QuestionId:data.data.data.QuestionList[x].QuestionId,
								Answer:'',
								ArrAnswer:[],
							}
							_that.AnswerList.push(str)
						}
					}
					console.log(_that.AnswerList)
					_that.formatTimer();

				}
				else {
					_that.$confirm(data.data.ErrorMsg, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						_that.redirectToPlayer();
						return false;
					})
				}
			}, function (data) {
				_that.$confirm('试卷加载失败?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_that.redirectToPlayer();
					return false;
				})
			})

		}
	}
</script>

<style >
	.hover{background:#0f6c8d;}
	.foot{width:100%; height:50px; clear:both;}
	.test_main{width:1200px;  margin:15px auto 0;}
	.nr_left{width:900px; height:100%; float:left;}
	.test{ width:100%;  border:1px solid #e4e4e4; text-align:left; float:left;}
	.test_title{width:900px; height:45px; line-height:45px; background-color:#f7f7f7;position:fixed; bottom:0; z-index:1000;}
	.test_title p{padding:0 20px; display:block; float:left;}
	.test_time{color:#f00; line-height:45px;}
	.test_time i{font-size:20px; height:45px; line-height:40px; display:block; float:left}
	.test_time b{font-size:16px; height:45px; display:block; float:left; margin-left:10px;}
	.test_dtk {line-height:45px;}
	.test_dtk i{font-size:22px; height:45px; line-height:45px; display:block; float:left; color:#389fc3;}
	.test_dtk span{font-size:14px; height:45px; display:block; float:left; margin-left:10px;}
	.test_title font{width:80px; height:45px;  display:block; float:right; text-align:center; }
	.test_title font input{background:#389fc3; border:none; display:block; width:80px; height:45px; cursor:pointer; color:#fff; font-size:16px; font-weight:bold;}
	.test_title font input:active{background:#79aef0;}
	.test_content{width:100%; height:auto; margin-top:15px;}
	.test_content_title{width:100%; height:50px; line-height:50px; background:#f7f7f7; text-align:center;}
	.test_content_title h2{padding:0 30px; font-size:16px; font-weight:normal; display:block; float:left}
	.test_content_title p{padding:0 10px; height:40px; line-height:40px; background:#389fc3; color:#fff; border-radius:30px; display:block; float:left; margin-top:5px;}
	.test_content_nr{width:100%; border-top:3px solid #efefef;padding-bottom: 45px;}
	.test_content_nr>ul>li{width:100%;  border-bottom:5px solid #efefef; padding-top:10px;}
	.test_content_nr_tt{width:85%; height:auto; line-height:32px; margin:0 auto; border-bottom:1px solid #e4e4e4;}
	.test_content_nr_tt i{width:25px; height:25px; line-height:25px; text-align:center; display:block; float:left; background:#5d9cec; border-radius:50%; margin-left:-50px; color:#fff; margin-top:8px; font-size:16px;}
	.test_content_nr_tt span{padding:0 8px;}
	.test_content_nr_tt font{font-size:14px}
	.test_content_nr_tt b{display:block; float:right; margin-right:-50px; color:#f48c27; font-size:20px;}
	.test_content_nr_main{width:85%; margin:0 auto; padding:10px 0;height:auto;}
	.option{line-height:32px; display:block; background:#fff;color:#666;}
	.option:hover{background:#e4e4e4;}
	.option input{width:20px; height:20px; display:block; float:left; margin:10px 10px 0 0;}
	.option label{height:auto;display:block;}
	.test_more_nr_main{width:85%; margin:0 auto; padding:10px 0;}
	.multiple{width:100%; height:40px; line-height:40px; display:block; background:#fff; margin-bottom:3px;}
	.multiple:hover{background:#e4e4e4;}
	.multiple dd input{width:20px; height:20px; display:block; float:left; margin:10px 10px 0 0;}
	.multiple dd label{width:725px; height:40px; display:block; float:left;}
	.test_click{background:#7aaff3; }
	.test_click a{color:#fff;}
	/*nr_right start*/
	.nr_right{width:280px; height:100%; float:right;}
	.nr_rt_main{width:100%; height:auto;}
	.rt_nr1{width:280px;position: fixed; top:15px; z-index:1000;}
	.rt_nr1_title{width:280px; height:45px; line-height:45px; background:#f3f3f3;}
	.rt_nr1_title h1{width:130px; height:45px; background:#389fc3; text-align:center; font-size:14px; display:block; float:left; color:#fff;}
	.rt_nr1_title h1 i{padding:0 5px; font-size:14px; font-weight:normal;}
	.rt_nr1_title p{width:141px; height:43px;  padding-right:8px; border:1px solid #e4e4e4; border-left:0; display:block; float:right;}
	.rt_nr1_title p i{margin-left:10px;}
	.rt_content{width:278px; height:100%; border:1px solid #e4e4e4; border-top:0;}
	.rt_content_tt{width:95%; height:40px; line-height:40px; margin:0 auto; border-bottom:1px solid #e4e4e4;}
	.rt_content_tt h2{width:150px; font-size:14px; display:inline-block;}
	.rt_content_tt p{width:100px; display:inline-block;}
	.answerSheet ul{padding:10px; text-align:left;}
	.answerSheet li{ display:inline-block;margin-bottom:5px; height:30px; width:30px; line-height:30px; text-align:center; border:1px solid #e4e4e4;}
	.answerSheet li a{display:block;}
	.answerSheet li:hover{color:#389fc3;border-color: #389fc3;}
	.rt_more{width:278px; height:100%; border:1px solid #e4e4e4; border-top:0;}
	.rt_more_tt{width:95%; height:40px; line-height:40px; margin:0 auto; border-bottom:1px solid #e4e4e4;}
	.rt_more_tt h2{width:150px; font-size:14px; display:inline-block;}
	.rt_more_tt p{width:100px; display:inline-block;}
	.rt_more_nr ul{padding:10px; text-align:left;}
	.rt_more_nr ul li{ display:inline-block; margin:5px; height:30px; width:30px; line-height:30px; text-align:center; border:1px solid #e4e4e4;}
	.hasBeenAnswer{background: #5d9cec;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/answer/Answer.vue